(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rm-purchase"] && !Shopify.designMode) return;
  try {
    class RMPurchase extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.data = JSON.parse(this.querySelector('[data-purchase-data]').textContent);
    this.text = this.data.text;
    this.form = this.querySelector('form');
    this.sticky = this.querySelector('[data-sticky]');
    this.stage = this.querySelector('[data-stage]');
    this.images = this.data.images;
    this.index = Math.max(0, this.images.findIndex(image => image.id === this.data.initialImage));
    this.request = 0;
    this.slides = [];
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.autoplay = !this.reduced.matches;
    const { signal } = this.controller;
    this.addEventListener('click', event => this.click(event), { signal });
    this.addEventListener('change', event => {
      if (event.target.matches('.rm-purchase__radio, [name="selling_plan"]')) this.updateVariant(true);
    }, { signal });
    this.form.addEventListener('submit', event => this.addToCart(event), { signal });
    document.addEventListener('click', event => {
      const item = event.target.closest('topbar-component [data-vars]');
      if (item?.closest('topbar-component').dataset.productId === this.dataset.productId) this.selectVariant(JSON.parse(item.dataset.vars).id);
    }, { signal });
    document.addEventListener('submit', event => {
      if (event.target.closest('topbar-component')?.dataset.productId !== this.dataset.productId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.form.requestSubmit();
    }, { signal, capture: true });
    this.stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, { signal });
    this.stage.addEventListener('pointerdown', event => { this.pointerX = event.clientX; }, { signal });
    this.stage.addEventListener('pointerup', event => {
      const distance = event.clientX - this.pointerX;
      if (event.pointerType !== 'mouse' && Math.abs(distance) > 45) {
        this.swiped = true;
        this.showImage(this.index + (distance < 0 ? 1 : -1));
      }
    }, { signal });
    this.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, { signal });
    });
    document.addEventListener('close', () => this.syncPlayback(), { signal, capture: true });
    document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
    this.reduced.addEventListener('change', () => { this.autoplay = !this.reduced.matches; this.syncPlayback(); }, { signal });
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.syncPlayback(); });
    this.observer.observe(this.stage);
    this.stage.querySelector('img')?.addEventListener('load', () => this.syncPlayback(), { signal });
    this.updateVariant(false);
    if (this.sticky) this.setupSticky();
    this.updateDates();
    this.resetPlayback();
    if (document.querySelector('topbar-component')) customElements.whenDefined('topbar-component').then(() => {
      if (this.isConnected) this.syncTopbar();
    });
  }

  disconnectedCallback() {
    this.controller.abort();
    this.observer.disconnect();
    this.stickyObserver?.disconnect();
    this.stickyResize?.disconnect();
    document.body.classList.remove('rm-sticky-ready', 'rm-purchase-controls-visible', 'rm-purchase-info-visible');
    document.body.style.removeProperty('--rm-sticky-height');
    this.progress?.cancel();
    this.slides.forEach(animation => animation.cancel());
    this.request++;
  }

  click(event) {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.hasAttribute('data-image-id')) this.showImage(this.images.findIndex(image => image.id === Number(target.dataset.imageId)));
    if (target.hasAttribute('data-previous')) this.showImage(this.index - 1);
    if (target.hasAttribute('data-next')) this.showImage(this.index + 1);
    if (target.hasAttribute('data-playback')) { this.autoplay = !this.autoplay; this.syncPlayback(); }
    if (target.hasAttribute('data-close')) target.closest('dialog').close();
    if (target.hasAttribute('data-hsa-open')) this.openDialog('[data-hsa-dialog]');
    if (target.hasAttribute('data-zoom')) {
      if (this.swiped) { this.swiped = false; return; }
      const image = this.images[this.index];
      if (!image) return;
      const zoom = this.querySelector('[data-zoom-image]');
      zoom.src = image.src;
      zoom.alt = image.alt;
      this.openDialog('[data-zoom-dialog]');
    }
  }

  openDialog(selector) {
    this.querySelector(selector)?.showModal();
    this.syncPlayback();
  }

  updateVariant(changeUrl) {
    const options = [...this.querySelectorAll('[data-option-position]')].map(fieldset => fieldset.querySelector('input:checked')?.value);
    const variant = options.length ? this.data.variants.find(item => item.options.every((value, index) => value === options[index])) : this.data.variants.find(item => item.id === this.data.initialVariant);
    this.variant = variant;
    this.querySelectorAll('[data-option-position]').forEach(fieldset => { const input = fieldset.querySelector('input:checked'); fieldset.querySelector('[data-option-name]').textContent = input?.dataset.label || input?.value || ''; });
    const available = Boolean(variant?.available);
    this.querySelector('[data-add]').disabled = !available;
    this.querySelector('[data-add-label]').textContent = variant ? (available ? this.text.add : this.text.soldOut) : this.text.unavailable;
    this.querySelector('[data-accelerated]').hidden = !available;
    this.form.elements.id.value = variant?.id || '';
    this.querySelector('[data-status]').textContent = '';
    if (!variant) { this.syncSticky(); return; }
    const allocation = variant.plans?.find(plan => String(plan.id) === this.form.elements.selling_plan?.value);
    const price = allocation || variant;
    const onSale = price.compare > price.price;
    this.querySelector('[data-price]').innerHTML = price.priceHtml;
    this.querySelector('[data-compare]').innerHTML = price.compareHtml;
    this.querySelector('[data-discount]').textContent = this.text.discount.replace('[percent]', Math.round((1 - price.price / price.compare) * 100));
    this.querySelector('[data-savings]').innerHTML = this.text.saving.replace('[amount]', price.savingHtml);
    ['[data-compare]', '[data-discount]', '[data-savings]'].forEach(selector => { this.querySelector(selector).hidden = !onSale; });
    this.form.elements.quantity.value = variant.minimum;
    this.querySelector('[data-delivery]').hidden = !variant.requiresShipping;
    this.querySelector('[data-shipping-label]').textContent = this.dataset.country === 'US' && this.dataset.currency === 'USD' && price.price * variant.minimum >= 5900 ? this.text.freeShipping : this.text.shippingPolicy;
    const imageIndex = this.images.findIndex(image => image.id === variant.imageId);
    if (imageIndex >= 0 && imageIndex !== this.index) this.showImage(imageIndex);
    if (changeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      this.form.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.syncTopbar();
  }

  selectVariant(id) {
    const variant = this.data.variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    this.querySelectorAll('[data-option-position]').forEach((fieldset, index) => {
      fieldset.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; });
    });
    this.updateVariant(true);
  }

  syncTopbar() {
    this.syncSticky();
    if (!this.variant) return;
    this.dispatchEvent(new CustomEvent('variant:selected', { bubbles: true, detail: { resource: { id: String(this.variant.id) } } }));
    requestAnimationFrame(() => {
      const bar = [...document.querySelectorAll('topbar-component')].find(item => item.dataset.productId === this.dataset.productId);
      if (!bar) return;
      const price = bar.querySelector('.topbar-total');
      const saving = bar.querySelector('.topbar-save');
      const savingLabel = bar.querySelector('.save_price > span');
      const button = bar.querySelector('button[type="submit"]');
      if (price) price.innerHTML = this.querySelector('[data-price]').innerHTML;
      if (saving) saving.innerHTML = this.variant.savingHtml;
      if (savingLabel) savingLabel.textContent = this.text.discount.replace('[percent]', Math.round((1 - this.variant.price / this.variant.compare) * 100));
      if (button) { button.disabled = this.adding || !this.variant.available; button.textContent = this.adding ? this.text.adding : (this.variant.available ? this.text.add : this.text.soldOut); }
    });
  }

  setupSticky() {
    const { signal } = this.controller;
    const purchase = this.querySelector('.rm-purchase__grid');
    this.purchasePassed = false;
    document.body.classList.add('rm-sticky-ready');
    const measure = () => {
      const height = Math.ceil(this.sticky.getBoundingClientRect().height);
      document.body.style.setProperty('--rm-sticky-height', this.sticky.hidden ? '0px' : `${height}px`);
    };
    const update = () => {
      const keyboard = window.visualViewport && innerHeight - window.visualViewport.height > 150;
      const hide = !this.purchasePassed || this.footerVisible || keyboard;
      this.sticky.hidden = Boolean(hide);
      document.body.classList.toggle('rm-purchase-controls-visible', Boolean(this.purchaseVisible));
      measure();
    };
    this.stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === purchase) this.purchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        else if (entry.target === this.querySelector('.rm-purchase__info')) document.body.classList.toggle('rm-purchase-info-visible', entry.isIntersecting);
        else if (entry.target === this.querySelector('[data-add]')) this.purchaseVisible = entry.isIntersecting;
        else this.footerVisible = entry.isIntersecting;
      });
      update();
    });
    this.stickyObserver.observe(purchase);
    this.stickyObserver.observe(this.querySelector('[data-add]'));
    this.stickyObserver.observe(this.querySelector('.rm-purchase__info'));
    const footer = document.querySelector('#rm-global-footer');
    if (footer) this.stickyObserver.observe(footer);
    this.stickyResize = new ResizeObserver(measure);
    this.stickyResize.observe(this.sticky);
    window.visualViewport?.addEventListener('resize', update, { signal });
    update();
  }

  syncSticky() {
    if (!this.sticky) return;
    const button = this.querySelector('[data-sticky-add]');
    button.disabled = this.adding || !this.variant?.available;
    button.textContent = this.adding ? this.text.adding : (this.variant ? (this.variant.available ? this.text.add : this.text.soldOut) : this.text.unavailable);
    button.setAttribute('aria-busy', String(Boolean(this.adding)));
    this.querySelector('[data-sticky-price]').innerHTML = this.variant ? this.querySelector('[data-price]').innerHTML : '';
    const status = this.querySelector('[data-status]');
    const error = this.querySelector('[data-sticky-error]');
    error.textContent = status.dataset.error === 'true' ? status.textContent : '';
    error.hidden = !error.textContent;
  }

  async addToCart(event) {
    event.preventDefault();
    if (this.adding || !this.variant?.available) return;
    this.adding = true;
    this.syncTopbar();
    const button = this.querySelector('[data-add]');
    const label = this.querySelector('[data-add-label]');
    const status = this.querySelector('[data-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = this.text.adding;
    status.textContent = '';
    status.dataset.error = 'false';
    this.syncSticky();
    const formData = new FormData(this.form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0, 5);
    if (sections.length) formData.set('sections', sections.join(','));
    formData.set('sections_url', location.pathname);
    try {
      const response = await fetch(this.dataset.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || this.text.error);
      this.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: result, sourceId: String(formData.get('id')), data: { source: 'product-form-component', productId: this.dataset.productId, itemCount: Number(formData.get('quantity')), sections: result.sections } } }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        await customElements.whenDefined('cart-drawer-component');
        drawer.open();
        this.syncPlayback();
      } else location.assign(this.dataset.cartUrl);
    } catch (error) {
      status.dataset.error = 'true';
      status.textContent = error.message || this.text.error;
    } finally {
      this.adding = false;
      this.syncTopbar();
      button.disabled = !this.variant?.available;
      button.removeAttribute('aria-busy');
      label.textContent = this.variant?.available ? this.text.add : this.text.soldOut;
    }
  }

  async showImage(index) {
    if (!this.images.length) return;
    const nextIndex = (index + this.images.length) % this.images.length;
    if (nextIndex === this.index && !this.changing) { this.resetPlayback(); return; }
    const request = ++this.request;
    const direction = index < this.index ? -1 : 1;
    const item = this.images[nextIndex];
    this.changing = true;
    this.syncPlayback();
    const image = new Image();
    image.src = item.src;
    image.alt = item.alt;
    image.width = item.width;
    image.height = item.height;
    image.className = 'rm-purchase__image';
    try { await image.decode(); } catch {
      if (request === this.request) { this.changing = false; this.resetPlayback(); }
      return;
    }
    if (request !== this.request) return;
    this.slides.forEach(animation => animation.cancel());
    this.stage.querySelectorAll('[data-frame][aria-hidden]').forEach(frame => frame.remove());
    const previous = this.stage.querySelector('[data-frame]');
    previous.setAttribute('aria-hidden', 'true');
    const next = document.createElement('span');
    next.className = 'rm-purchase__frame';
    next.dataset.frame = '';
    next.append(image);
    this.stage.querySelector('.rm-purchase__image-button').append(next);
    this.index = nextIndex;
    this.querySelectorAll('[data-image-id]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.imageId) === item.id)));
    this.resetPlayback();
    if (!this.reduced.matches) {
      const timing = { duration: 500, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' };
      this.slides = [previous.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${direction * 100}%)` }], timing), next.animate([{ transform: `translateX(${-direction * 100}%)` }, { transform: 'translateX(0)' }], timing)];
      this.syncPlayback();
      await Promise.all(this.slides.map(animation => animation.finished.catch(() => {})));
    }
    if (request !== this.request) return;
    previous.remove();
    this.slides.forEach(animation => animation.cancel());
    this.slides = [];
    this.changing = false;
    this.syncPlayback();
  }

  resetPlayback() {
    this.progress?.cancel();
    const indicator = this.querySelector('[data-image-id][aria-pressed="true"] i');
    if (!indicator || this.images.length < 2) return;
    this.progress = indicator.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: 6000, fill: 'forwards' });
    this.progress.onfinish = () => this.showImage(this.index + 1);
    this.syncPlayback();
  }

  syncPlayback() {
    const image = this.stage.querySelector('[data-frame]:not([aria-hidden]) img');
    const visible = this.visible && !document.hidden && !document.querySelector('dialog[open]');
    const playing = visible && this.autoplay && !this.changing && image?.complete && image.naturalWidth > 0;
    if (this.progress) playing ? this.progress.play() : this.progress.pause();
    this.slides.forEach(animation => visible ? animation.play() : animation.pause());
    const button = this.querySelector('[data-playback]');
    if (button) { button.dataset.paused = String(!this.autoplay); button.setAttribute('aria-label', this.autoplay ? this.text.pause : this.text.play); }
  }

  updateDates() {
    const start = new Date();
    const end = new Date(start);
    start.setDate(start.getDate() + 2);
    end.setDate(end.getDate() + 8);
    const formatter = new Intl.DateTimeFormat(this.dataset.locale, { month: 'short', day: 'numeric' });
    this.querySelector('[data-delivery-dates]').textContent = formatter.formatRange(start, end);
  }
}

if (!customElements.get('rm-purchase')) customElements.define('rm-purchase', RMPurchase);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rmh-air-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root = document) {
    root.querySelectorAll('[data-rmh-air-motion]').forEach(stage => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let animations = [], visible = false, ready = false, finished = false;
      const reset = () => {
        finished = false;
        stage.classList.remove('is-entering');
        animations.forEach(animation => animation.cancel());
        animations = [];
      };
      const finish = () => {
        reset();
        finished = true;
      };
      const sync = () => {
        if (!ready || finished || reduced.matches) return;
        if (!animations.length && visible && !document.hidden) {
          stage.classList.add('is-entering');
          animations = [...stage.querySelectorAll('.rmh-air-layer')].map((layer, index) => {
            const css = getComputedStyle(layer);
            return layer.animate([
              { transform: `translate3d(${css.getPropertyValue('--enter-x')},${css.getPropertyValue('--enter-y')},0) rotate(${css.getPropertyValue('--enter-angle')})`, opacity: 0 },
              { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 }
            ], { duration: 1700, delay: index * 90, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' });
          });
          const playing = animations;
          Promise.all(playing.map(animation => animation.finished)).then(() => {
            if (animations === playing) finish();
          }).catch(() => {});
        }
        animations.forEach(animation => visible && !document.hidden ? animation.play() : animation.pause());
      };
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        visible = entry.isIntersecting && entry.intersectionRatio >= .15;
        if (!entry.isIntersecting) reset();
        sync();
      }, { threshold: [0, .15] });
      observer.observe(stage);
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', () => { reset(); sync(); });
      stage.querySelector('img').decode().then(() => { ready = true; sync(); }).catch(reset);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
